/* ============================================================
   Generic accordion groups — [data-accordion] (Topics, FAQ)
   ------------------------------------------------------------
   Single-open-per-group `.accordion-item` list; toggles `is-open`
   and keeps `.accordion-trigger[aria-expanded]` in sync.
   Mirrors csd-common.css / faq.css / software-type.css accordion styles.
   ============================================================ */
// export function initAccordionGroups() {
//   document.querySelectorAll("[data-accordion]").forEach(function (group) {
//     var items = Array.prototype.slice.call(
//       group.querySelectorAll(".accordion-item")
//     );

//     items.forEach(function (item) {
//       var trigger = item.querySelector(".accordion-trigger");
//       if (!trigger) return;

//       trigger.setAttribute(
//         "aria-expanded",
//         item.classList.contains("is-open") ? "true" : "false"
//       );

//       trigger.addEventListener("click", function () {
//         var willOpen = !item.classList.contains("is-open");
//         items.forEach(function (other) {
//           other.classList.remove("is-open");
//           var t = other.querySelector(".accordion-trigger");
//           if (t) t.setAttribute("aria-expanded", "false");
//         });
//         if (willOpen) {
//           item.classList.add("is-open");
//           trigger.setAttribute("aria-expanded", "true");
//         }
//       });
//     });
//   });
// }
export function initAccordionGroups() {
  document.querySelectorAll("[data-accordion]").forEach(function (group) {
    var items = Array.prototype.slice.call(
      group.querySelectorAll(".accordion-item")
    );

    items.forEach(function (item) {
      var trigger = item.querySelector(".accordion-trigger");
      if (!trigger) return;

      trigger.setAttribute(
        "aria-expanded",
        item.classList.contains("is-open") ? "true" : "false"
      );

      // Click on the entire accordion item
      item.addEventListener("click", function (e) {
        // Allow links inside the content to work normally
        if (e.target.closest("a")) return;

        var willOpen = !item.classList.contains("is-open");

        items.forEach(function (other) {
          other.classList.remove("is-open");
          var t = other.querySelector(".accordion-trigger");
          if (t) t.setAttribute("aria-expanded", "false");
        });

        if (willOpen) {
          item.classList.add("is-open");
          trigger.setAttribute("aria-expanded", "true");
        }
      });
    });
  });
}